export const products = [
    {
        title: "Oscilloscopes & Signal Generators",
        list: [
            {
                img: "https://assets.testequity.com/te1/Images/categories/Mixed_Signal_Oscilloscopes_small.jpg",
                text: "Mixed Signal Oscilloscope",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Digital_Oscilloscopes_small.jpg",
                text: "Digital Oscilloscopes",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Handheld_Oscilloscopes_small.jpg",
                text: "Handheld Oscilloscopes",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Analog_Oscilloscopes_small.jpg",
                text: "Analog Oscilloscopes",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Oscilloscope_Probe_small.jpg",
                text: "Oscilloscope Probes",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Application_Software_small.jpg",
                text: "Application Software",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Accessories_Carts_Cases_small.jpg",
                text: "Accessories, Carts, Cases",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Upgrade_small.jpg",
                text: "Calibration, Service, Upgrade Options",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Generators_small.jpg",
                text: "Signal Generators",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Logic_Analyzers_and_Probes_small.jpg",
                text: "Logic Analyzers & Probes",
            },
        ],
    },
    {
        title: "Environmental Chambers, Ovens",
        list: [
            {
                img: "https://assets.testequity.com/te1/Images/categories/Forced_Air_Ovens_small.jpg",
                text: "Forced Air Ovens",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Gravity_Convection_Ovens_small.jpg",
                text: "Gravity Convection Ovens",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Temperature_Chambers_small.jpg",
                text: "Temperature Chambers",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Temperature_Humidity_Chambers_small.jpg",
                text: "Temperature-Humidity Chambers",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Vacuum_Ovens_small.jpg",
                text: "Vacuum Ovens",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/ChamberAccessoresAndParts_small.jpg.jpg",
                text: "Accessories & Parts",
            },
        ],
    },
    {
        title: "Data Acquisition and Meters",
        list: [
            {
                img: "https://assets.testequity.com/te1/Images/categories/AC_Power_Quality_Analyzers_small.jpg",
                text: "AC Power Quality Analyzers",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Data_Acquistition_Systems_small.jpg",
                text: "Data Acquisition",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Multimeters_small.jpg",
                text: "Multimeters",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Electrical_Testers_small.jpg",
                text: "Electrical Testers & Analyzers",
            },
            {
                img:
                    "https://assets.testequity.com/te1/Images/categories/Environmental_and_Temperature_Testers_small.jpg",
                text: "Environmental & Temperature Testers",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Multimeter_Leads_and_Probes_small.jpg",
                text: "Test Leads & Accessories",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Thermal_Imaging_small.jpg",
                text: "Thermal Imaging",
            },
        ],
    },
    {
        title: "Network & Spectrum Analyzers",
        list: [
            {
                img: "https://assets.testequity.com/te1/Images/categories/Network_Analyzers_small.jpg",
                text: "Network Analyzers",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Spectrum_Analyzer_small.jpg",
                text: "Spectrum Analyzers",
            },
        ],
    },
    {
        title: "Networking & Telecommunications",
        list: [
            {
                img: "https://assets.testequity.com/te1/Images/categories/Datacommunication_small.jpg",
                text: "Data Communication",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Fiber_Optic_small.jpg",
                text: "Fiber Optic",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Mobile_Communication_Analyzers_small.jpg",
                text: "Mobile Communication Analyzers",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/TV_and_Video_small.jpg",
                text: "TV and Video",
            },
        ],
    },
    {
        title: "Power Supplies",
        list: [
            {
                img: "https://assets.testequity.com/te1/Images/categories/DC_Power_Supplies_small.jpg",
                text: "DC Power Supplies",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/AC_Power_Source_small.jpg",
                text: "AC Power Source",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Electronic_Load_small.jpg",
                text: "Electronic Load",
            },
        ],
    },
    {
        title: "Component Measurement",
        list: [
            {
                img: "https://assets.testequity.com/te1/Images/categories/LCR_and_Impedance_Meters_small.jpg",
                text: "LCR Impedance",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Battery_Analyzer_small.jpg",
                text: "Battery Analyzer",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Device_Programmer_small.jpg",
                text: "Device Programmers",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/EPROM_Erasers_small.jpg",
                text: "EPROM Erasers",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Semiconductor_small.jpg",
                text: "Semiconductor Analyzers",
            },
        ],
    },
    {
        title: "RF & Microwave",
        list: [
            {
                img: "https://assets.testequity.com/te1/Images/categories/RF_Measurement_small.jpg",
                text: "RF Measurement",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/RF_Signal_Generators_small.jpg",
                text: "RF Signal Generators",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/RF_Cables_Connectors_and_Adapters_small.jpg",
                text: "RF Test Accessories",
            },
        ],
    },
    {
        title: "Accessories",
        list: [
            {
                img: "https://assets.testequity.com/te1/Images/categories/Connectivity_Software_small.jpg",
                text: "Connectivity, Software",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Rack_Mount_Hardware_small.jpg",
                text: "Rack Mount Hardware",
            },
        ],
    },
    {
        title: "Other Instruments",
        list: [
            {
                img: "https://assets.testequity.com/te1/Images/categories/Audio_Distortion_Analyzers_small.jpg",
                text: "Audio Distortion Analyzers",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Calibrators_small.jpg",
                text: "Calibrators",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Frequency_Counters_small.jpg",
                text: "Frequency Counters",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Hipot_Electrical_Safety_small.jpg",
                text: "Hipot, Electrical Safety",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Mechanical_Properties_Test_Meters_small.jpg",
                text: "Mechanical Properties Test Meters",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Specialty_Instruments_small.jpg",
                text: "Specialty Instruments",
            },
            {
                img: "https://assets.testequity.com/te1/Images/categories/Other_Options_small.jpg",
                text: "Options",
            },
        ],
    },
    {
        title: "Electronic Production Supplies",
        list: [
            {
                img: "https://assets.testequity.com/te1/category-images/vests.jpg",
                text: "Apparel",
            },
            {
                img: "https://assets.testequity.com/te1/category-images/benches_accessories.jpg",
                text: "Benches, Workstations & Seating",
            },
            {
                img: "https://assets.testequity.com/te1/category-images/dispensing_systems.jpg",
                text: "Bottles & Dispensers",
            },
            {
                img: "https://assets.testequity.com/te1/category-images/tool_cases.jpg",
                text: "Cases & Tool Organizers",
            },
            {
                img: "https://assets.testequity.com/te1/category-images/cleaning_products.jpg",
                text: "Chemicals, Cleaning & Abrasives",
            },
            {
                img: "https://assets.testequity.com/te1/category-images/adhesive_mats.jpg",
                text: "Cleanroom",
            },
            {
                img: "https://assets.testequity.com/te1/category-images/hand_tools.jpg",
                text: "Hand & Power Tools",
            },
            {
                img: "https://assets.testequity.com/te1/category-images/printers.jpg",
                text: "Labels, Printers & Paper Supplies",
            },
            {
                img: "https://assets.testequity.com/te1/category-images/magnifiers.jpg",
                text: "Magnification & Lighting",
            },
            {
                img: "https://assets.testequity.com/te1/category-images/network_hardware.jpg",
                text: "Networking, Telecom & Fiber",
            },
            {
                img: "https://assets.testequity.com/te1/category-images/extension_cords.jpg",
                text: "Power Management",
            },
            {
                img: "https://assets.testequity.com/te1/category-images/lockout_tagout.jpg",
                text: "Safety Supplies",
            },
            {
                img: "https://assets.testequity.com/te1/category-images/stations_irons3.jpg",
                text: "Solder & Desolder",
            },
            {
                img: "https://assets.testequity.com/te1/category-images/personal_static_protection_grounding.jpg",
                text: "Static Protection",
            },
            {
                img: "https://assets.testequity.com/te1/category-images/shelving_racks_storage_cabinets.jpg",
                text: "Storage & Handling",
            },
            {
                img: "https://assets.testequity.com/te1/Images/support/noimage.jpg",
                text: "Tool Kits",
            },
        ],
    },
];
